import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HtmlLink from './icon-html-link.svg';

type Props = {
    fill?: string;
};
function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <HtmlLink {...validProps} fill={props.fill} />;
}
SvgComponent.iconName = 'html-link';

/**
 * @deprecated This is a legacy icon
 */
export const HtmlLinkIcon = svgIconWrapper(SvgComponent);
